// extracted by mini-css-extract-plugin
export default {"appFilterMenuItem":"AppFilterDropdown_appFilterMenuItem__xTSL+","activeFilterIconContainer":"AppFilterDropdown_activeFilterIconContainer__MrEsy"};